import type { CrmContact } from '@ip/shared-types';

/** "Jan Kowalski" — a contact may have no last name. */
export function contactName(contact: Pick<CrmContact, 'firstName' | 'lastName'>): string {
  return [contact.firstName, contact.lastName].filter(Boolean).join(' ');
}
